'use client';

import * as React from 'react';
import Skeleton, { SkeletonTheme } from 'react-loading-skeleton';
import 'react-loading-skeleton/dist/skeleton.css';
import { TableRow, TableCell } from '@/components/ui/table';

interface PromotionsTableSkeletonProps {
    rows?: number;
}

/**
 * PromotionsTableSkeleton component for displaying loading state
 * Returns only table rows to be inserted into existing table structure
 */
export const PromotionsTableSkeleton = ({ rows = 10 }: PromotionsTableSkeletonProps) => {
    return (
        <SkeletonTheme baseColor="#f8fafc" highlightColor="#f1f5f9" borderRadius="0.375rem">
            <>
                {Array.from({ length: rows }, (_, index) => (
                    <TableRow key={index}>
                        {/* Select Checkbox */}
                        <TableCell className="w-10">
                            <Skeleton height={16} width={16} />
                        </TableCell>

                        {/* ID */}
                        <TableCell className="w-24">
                            <Skeleton height={20} width={80} />
                        </TableCell>

                        {/* Promotion Name & Code */}
                        <TableCell>
                            <div className="space-y-1">
                                <Skeleton height={16} width={180} />
                                <Skeleton height={12} width={120} />
                            </div>
                        </TableCell>

                        {/* Discount */}
                        <TableCell className="w-32">
                            <Skeleton height={16} width={80} />
                        </TableCell>

                        {/* Status Badge */}
                        <TableCell className="w-24">
                            <Skeleton height={20} width={70} borderRadius="0.375rem" />
                        </TableCell>

                        {/* Valid Period */}
                        <TableCell className="w-40">
                            <div className="space-y-1">
                                <Skeleton height={14} width={120} />
                                <Skeleton height={14} width={120} />
                            </div>
                        </TableCell>

                        {/* Actions */}
                        <TableCell className="w-10">
                            <Skeleton height={32} width={32} borderRadius="0.25rem" />
                        </TableCell>
                    </TableRow>
                ))}
            </>
        </SkeletonTheme>
    );
};

